// src/index.ts
import { getAxios } from "@coremind/identity-core";
var api = () => getAxios();
var listUsers = async () => {
  const response = await api().get("/admin/users");
  return response.data;
};
var listRoles = async () => {
  const response = await api().get("/admin/roles");
  return response.data;
};
var createRole = async (payload) => {
  const response = await api().post("/admin/roles", payload);
  return response.data;
};
var updateRole = async (roleId, payload) => {
  const response = await api().put(`/admin/roles/${roleId}`, payload);
  return response.data;
};
var listGroups = async () => {
  const response = await api().get("/admin/groups");
  return response.data;
};
var updateUserRoles = async (userId, payload) => {
  const response = await api().put(
    `/admin/users/${userId}/roles`,
    payload
  );
  return response.data;
};
var updateUserGroups = async (userId, payload) => {
  const response = await api().put(
    `/admin/users/${userId}/groups`,
    payload
  );
  return response.data;
};
export {
  createRole,
  listGroups,
  listRoles,
  listUsers,
  updateRole,
  updateUserGroups,
  updateUserRoles
};
